import { render } from "./AddQualificationModal.vue?vue&type=template&id=22f4c09e&ts=true"
import script from "./AddQualificationModal.vue?vue&type=script&lang=ts"
export * from "./AddQualificationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__